export default __webpack_public_path__ + "static/media/cruise-ship.5ddbf576.svg";